import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  brands: null,
  loading: false,
  error: null,
  singleBrand: null,
  singleBrandLoading: false,
  singleBrandError: null,
  brandProducts: null,
  brandProductsLoading: false,
  brandProductsError: null
};

const brandsSlice = createSlice({
  name: 'brands',
  initialState,
  reducers: {
    getBrandsStart: (state) => {
      state.loading = true;
      state.error = null;
    },
    getBrandsSuccess: (state, action) => {
      state.loading = false;
      state.brands = action.payload;
    },
    getBrandsFailed: (state, action) => {
      state.loading = false;
      state.error = action.payload;
    },
    getSingleBrandStart: (state) => {
      state.singleBrandLoading = true;
      state.singleBrandError = null;
    },
    getSingleBrandSuccess: (state, action) => {
      state.singleBrandLoading = false;
      state.singleBrand = action.payload;
    },
    getSingleBrandFailed: (state, action) => {
      state.singleBrandLoading = false;
      state.singleBrandError = action.payload;
    },
    getBrandProductsStart: (state) => {
      state.brandProductsLoading = true;
      state.brandProductsError = null;
    },
    getBrandProductsSuccess: (state, action) => {
      state.brandProductsLoading = false;
      state.brandProducts = action.payload;
    },
    getBrandProductsFailed: (state, action) => {
      state.brandProductsLoading = false;
      state.brandProductsError = action.payload;
    }
  }
});

export const {
  getBrandsStart,
  getBrandsSuccess,
  getBrandsFailed,
  getSingleBrandStart,
  getSingleBrandSuccess,
  getSingleBrandFailed,
  getBrandProductsStart,
  getBrandProductsSuccess,
  getBrandProductsFailed
} = brandsSlice.actions;

export default brandsSlice.reducer;
